import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyCommunicationMediaApiService } from './company-communication-media-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyCommunicationMediaApiService extends GeneratedCompanyCommunicationMediaApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
